var _excluded = ["fieldId", "id", "children", "component", "hint", "textClassName", "className", "inversed", "errorMessage", "errorMessageClassName", "errorId", "requirementLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import InlineError from '../InlineError/InlineError';
import React from 'react';
import classNames from 'classnames';
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/form-label/).
 */
export var FormLabel = function FormLabel(props) {
  var fieldId = props.fieldId,
    id = props.id,
    children = props.children,
    component = props.component,
    hint = props.hint,
    textClassName = props.textClassName,
    className = props.className,
    inversed = props.inversed,
    errorMessage = props.errorMessage,
    errorMessageClassName = props.errorMessageClassName,
    errorId = props.errorId,
    requirementLabel = props.requirementLabel,
    labelProps = _objectWithoutProperties(props, _excluded);
  var hintElement;
  if (hint || requirementLabel) {
    var hintClasses = classNames('ds-c-field__hint', inversed && 'ds-c-field__hint--inverse');
    var hintPadding;
    var requirement = requirementLabel;
    if (requirementLabel && hint) {
      if (typeof requirementLabel === 'string') {
        // Remove any existing spacing and punctuation
        requirement = requirementLabel.trim().replace(/\.$/, '');
        // Add punctuation after the requirementLabel so it doesn't run into the hint
        requirement = requirementLabel + '.';
      }

      // Add space between hint and preceding requirementLabel
      hintPadding = ' ';
    }
    hintElement = /*#__PURE__*/React.createElement("span", {
      className: hintClasses
    }, requirement, hintPadding, hint);
  }
  var errorMessageElement;
  if (errorMessage) {
    // Include fallback for errorId
    var inlineErrorId;
    if (errorId) {
      inlineErrorId = errorId;
    } else if (fieldId) {
      inlineErrorId = "".concat(fieldId, "-error");
    }
    errorMessageElement = /*#__PURE__*/React.createElement(InlineError, {
      id: inlineErrorId,
      inversed: inversed,
      className: errorMessageClassName
    }, errorMessage);
  }
  var ComponentType = component;
  var classes = classNames('ds-c-label', className, inversed && 'ds-c-label--inverse');
  return /*#__PURE__*/React.createElement(ComponentType, _extends({
    className: classes,
    htmlFor: fieldId,
    id: id
  }, labelProps), /*#__PURE__*/React.createElement("span", {
    className: classNames(textClassName)
  }, children), hintElement, errorMessageElement);
};
FormLabel.defaultProps = {
  component: 'label'
};
export default FormLabel;